import React, {useState} from 'react'
import classNames from 'classnames'
import './index.scss'
import {ArrowDownIcon} from '../../../icons'
import {colors} from '../../../utils/colors'
import {useSelector} from 'react-redux'

const ExpandableBlock = ({blockTitle, children}) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const toggleSection = () => {
        setIsExpanded(!isExpanded)
    }

    return (
        <div className={classNames('url-section', {
            dark: isDarkMode
        })}>
            <span
                className={classNames('url-section-title-field', {
                    expanded: isExpanded
                })}
                onClick={toggleSection}
            >
                <h3 className='url-section-title'>{blockTitle}</h3>
                {<span className={classNames('url-section-icon', {
                    expanded: isExpanded
                })}>
                    <ArrowDownIcon  width={18} height={18} stroke={colors.colorBlue}/>
                </span>}
            </span>
            {isExpanded && <div className="block-body">
                <div className="child-container">
                    {children}
                </div>
            </div>}
        </div>
    )
}

export default ExpandableBlock
